import { useChain } from '@/chain/ChainProvider';

/** Setup mode (/api/health.platformId is ""): the platform is not created yet. */
export function SetupBanner() {
  const { setupMode } = useChain();
  if (!setupMode) return null;
  return <div className="setup-banner" role="status"><i /> Raydius is launching soon. Launching and trading open once the platform is live.</div>;
}
